"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _reactRouter = require("react-router");
var _commonTabs = require("@mmc/common-tabs");
var _commonCta = require("@mmc/common-cta");
var _modelSelector = require("@mmc/model-selector");
var _commonShareDialog = require("@mmc/common-share-dialog");
var _commonMediaQuery = require("@mmc/common-media-query");
var _themeProvider = require("@mmc/theme-provider");
var _formElements = require("@mmc/form-elements");
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _useCountUp = require("use-count-up");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _text = require("@mmc/text");
var _commonLoader = require("@mmc/common-loader");
var _reactRedux = require("react-redux");
var _reactApollo = require("react-apollo");
var _commonErrorMessage = require("@mmc/common-error-message");
var _commonI18n = require("@mmc/common-i18n");
var _zipCodeForm = require("./zipcode-form/zip-code-form");
var utils = _interopRequireWildcard(require("./calculation-form.utils"));
var _calculationForm2 = _interopRequireDefault(require("./calculation-form.default-props"));
var _paymentGraph = _interopRequireDefault(require("./payment-graph"));
var _input = _interopRequireDefault(require("./input"));
var _extraLinks = _interopRequireDefault(require("./extra-links"));
var _query = require("./query");
var _calculationForm3 = require("./calculation-form.prop-types");
var _calculationForm4 = _interopRequireDefault(require("./calculation-form.css"));
require("./odometer.css");
var _constants = require("./constants");
var _br, _CommonLoader, _br2, _CommonLoader2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /* eslint-disable react/no-unused-state */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable no-nested-ternary */
var CalculationForm = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(CalculationForm, _React$PureComponent);
  CalculationForm.resourceType = function resourceType() {
    return 'PaymentCalculator_1_0_0';
  };
  function CalculationForm(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    var selectedModelIndex = Number(_jsCookie["default"].get(_constants.vehicleKeyMap.SELECTED_MODEL_INDEX)) || undefined;
    var selectedTab = Number(_jsCookie["default"].get(_constants.vehicleKeyMap.SELECTED_TAB_INDEX)) || 0;
    var inlineData = _this.props.inlineData;
    _this.state = _objectSpread({
      isDefaultRate: true,
      isShareDialogOpen: false,
      screenWidth: 0,
      selectedModelIndex: selectedModelIndex,
      selectedTab: selectedTab,
      annualMileage: null,
      tradeInValue: null,
      rate: null,
      paymentModel: null,
      defaultBuyDownPayment: null,
      defaultBuyTradeInValue: null,
      buyInterestRate: null,
      isDeafultUrlDataFetched: false,
      zipCodeNumber: null
    }, inlineData);
    _this._cachedData = null;
    _this._defaultRate = null;
    _this.tabRef = /*#__PURE__*/_react["default"].createRef();
    _this.shareURL = '';
    _this.shareTitle = '';
    _this.shareText = '';
    _this.openShareDialog = _this.openShareDialog.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeShareDialog = _this.closeShareDialog.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleModelChange = _this.handleModelChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleButtonChange = _this.handleButtonChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getUrlData = _this.getUrlData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setUrlData = _this.setUrlData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDefaultUrlValues = _this.setDefaultUrlValues.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onQueryData = _this.onQueryData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setState = _this.setState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleCustomRate = _this.toggleCustomRate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onTabClick = _this.onTabClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.layoutAdjuster = _this.layoutAdjuster.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputChange = (0, _debounce2["default"])(_this.handleInputChange.bind((0, _assertThisInitialized2["default"])(_this)), 500);
    _this.refreshData = _this.refreshData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.emitCalculationUpdate = _this.emitCalculationUpdate.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = CalculationForm.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.layoutAdjuster();
    window.addEventListener('resize', this.layoutAdjuster);
    this.setDefaultUrlValues();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.layoutAdjuster);
  };
  _proto.handleButtonChange = function handleButtonChange(inputData, data, refetch) {
    this.refreshData(inputData, data, refetch);
  };
  _proto.handleModelChange = function handleModelChange(modelIndex, selectedModel, refetch) {
    var paymentModel = selectedModel.modelCode;
    var variables = {
      paymentModel: paymentModel
    };
    this.setUrlData({
      name: 'selectedModelIndex',
      value: modelIndex
    });
    this.setState({
      selectedModelIndex: modelIndex,
      paymentModel: paymentModel
    });
    refetch(variables);
  };
  _proto.handleInputChange = function handleInputChange(dataInput, data, refetch) {
    if (!dataInput.isShowError) {
      var _this$setState;
      this.setState((_this$setState = {}, _this$setState[dataInput.name] = dataInput.value, _this$setState));
      this.setUrlData({
        name: dataInput.name,
        value: dataInput.value
      });
      this.refreshData(dataInput, data, refetch);
    }
  };
  _proto.handleZipCodeChange = function handleZipCodeChange(dataInput, data, refetch) {
    if (!dataInput.isShowError) {
      var _this$setState2;
      this.setState((_this$setState2 = {}, _this$setState2[dataInput.name] = dataInput.value, _this$setState2));
      this.refreshData(dataInput, data, refetch);
    }
  };
  _proto.onTabClick = function onTabClick(index) {
    this.setState({
      selectedTab: index
    });
    var screenWidth = this.state.screenWidth;
    if (screenWidth <= _commonMediaQuery.BREAKPOINTS.xs.MAX && this.tabRef.current) {
      this.tabRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  _proto.onQueryData = function onQueryData(latestData) {
    var selectedModelIndex = this.state.selectedModelIndex,
      query = this.props.router.location.query;
    var _this$getGQLData = this.getGQLData(latestData),
      _this$getGQLData$vehi = _this$getGQLData.vehicles,
      vehicles = _this$getGQLData$vehi === void 0 ? [] : _this$getGQLData$vehi;
    var vehicleIsNotSelected = selectedModelIndex === undefined || selectedModelIndex === -1;
    if (vehicleIsNotSelected && vehicles.length) {
      var paymentModel = query.paymentModel || vehicles[0].modelCode;
      var defaultSelectedModelIndex = vehicles.findIndex(function (vehicle) {
        return vehicle.modelCode === paymentModel;
      });
      this.setState({
        selectedModelIndex: defaultSelectedModelIndex
      });
    }
  };
  _proto.setUrlData = function setUrlData(_ref) {
    var name = _ref.name,
      value = _ref.value;
    if (typeof window !== 'undefined') {
      var params = new URLSearchParams(window.location.search);
      params.set(name, value);
      var newParams = params.toString();
      this.props.router.replace({
        pathname: window.location.pathname,
        search: "?" + newParams
      });
    }
  };
  _proto.getUrlData = function getUrlData(_ref2) {
    var name = _ref2.name;
    if (typeof window !== 'undefined') {
      var params = new URLSearchParams(window.location.search);
      return params.get(name);
    }
  };
  _proto.setDefaultUrlValues = function setDefaultUrlValues() {
    var _this2 = this;
    var defaultValues = ['selectedModelIndex', 'buyDownPayment', 'buyTradeInValue', 'buyInterestRate'];
    defaultValues.forEach(function (name) {
      var value = _this2.getUrlData({
        name: name
      });
      if (value) {
        var _this2$setState;
        _this2.setState((_this2$setState = {}, _this2$setState[name] = value, _this2$setState));
        if (name === 'buyInterestRate') {
          _this2.setState({
            isDefaultRate: false
          });
        }
      }
    });
    this.setState({
      isDeafultUrlDataFetched: true
    });
  };
  _proto.getGQLData = function getGQLData(_temp) {
    var _ref3 = _temp === void 0 ? {} : _temp,
      getPaymentCalculatorSummary = _ref3.getPaymentCalculatorSummary,
      ContentPage = _ref3.ContentPage;
    var dataComponent = ContentPage && ContentPage.components.find(function (c) {
      return c.resourceType === CalculationForm.resourceType();
    });
    if (dataComponent && dataComponent.hasModelsOrdering && dataComponent.vehicles.length > 0) {
      dataComponent.vehicles.sort(function (a, b) {
        return Number(a.sortOrder) - Number(b.sortOrder);
      });
    }
    if (!getPaymentCalculatorSummary) {
      return _objectSpread(_objectSpread({}, _calculationForm2["default"].getPaymentCalculatorSummary), dataComponent);
    }
    var data = _objectSpread(_objectSpread({}, getPaymentCalculatorSummary), dataComponent);
    if (!this._cachedData) {
      this._cachedData = data;
    } else {
      // Partial update as the API sends empty labels & messes with the terms
      // after terms been provided by the user
      this._cachedData.financeCalculation = _objectSpread(_objectSpread({}, data.financeCalculation), {}, {
        terms: (0, _get2["default"])(this._cachedData, 'financeCalculation.terms')
      });
      this._cachedData.leaseCalculation = _objectSpread(_objectSpread({}, data.leaseCalculation), {}, {
        terms: (0, _get2["default"])(this._cachedData, 'leaseCalculation.terms')
      });
    }
    return this._cachedData;
  };
  _proto.refreshData = function refreshData(inputData, data, refetch) {
    var financeCalculation = data.financeCalculation,
      leaseCalculation = data.leaseCalculation,
      vehicles = data.vehicles;
    var _this$state = this.state,
      downPaymentAmount = _this$state.downPaymentAmount,
      rate = _this$state.rate,
      tradeInValue = _this$state.tradeInValue,
      annualMileage = _this$state.annualMileage,
      financeTerms = _this$state.financeTerms,
      selectedFinanceTerm = _this$state.financeTerm,
      isDefaultRate = _this$state.isDefaultRate,
      leaseTerms = _this$state.leaseTerms;
    var selectedModelIndex = this.state.selectedModelIndex;
    var selectedModel = vehicles && vehicles[selectedModelIndex] || '';
    var paymentModel = selectedModel && selectedModel.modelCode || '';
    var defaultFinanceTerm = Number(utils.getDefaultValue(financeCalculation.terms));
    var financeTerm = inputData.name === 'buyInterestRate' ? selectedFinanceTerm || defaultFinanceTerm : defaultFinanceTerm;
    var leaseTerm = Number(utils.getDefaultValue(leaseCalculation.terms));
    this.setState({
      paymentModel: paymentModel,
      financeTerm: financeTerm,
      leaseTerm: leaseTerm
    });
    var buyDownPayment = (0, _get2["default"])(financeCalculation, 'downPayment.value');
    var leaseDownPayment = (0, _get2["default"])(leaseCalculation, 'downPayment.value');
    var variables = {
      paymentModel: paymentModel
    };
    var financeData = {
      hasInteracted: true,
      calculatorData: _objectSpread(_objectSpread({
        downPaymentAmount: downPaymentAmount,
        financeTerm: financeTerm,
        leaseTerm: leaseTerm,
        rate: rate,
        tradeInValue: tradeInValue,
        annualMileage: annualMileage
      }, !financeTerms && {
        financeTerms: (0, _get2["default"])(financeCalculation, 'terms')
      }), !leaseTerms && {
        leaseTerms: (0, _get2["default"])(leaseCalculation, 'terms')
      })
    };
    switch (inputData.name) {
      case 'buyDownPayment':
      case 'leaseDownPayment':
        this.setState({
          downPaymentAmount: Number(inputData.value)
        });
        financeData.calculatorData.downPaymentAmount = Number(inputData.value);
        refetch(_objectSpread(_objectSpread({}, variables), {}, {
          downPaymentAmount: Number(inputData.value),
          financeTerm: financeTerm,
          leaseTerm: leaseTerm
        }));
        break;
      case 'buyTerm':
        this.setState({
          downPaymentAmount: buyDownPayment,
          financeTerm: Number(inputData.value)
        });
        financeData.calculatorData.financeTerm = Number(inputData.value);
        refetch(_objectSpread(_objectSpread({}, variables), {}, {
          downPaymentAmount: buyDownPayment,
          financeTerm: Number(inputData.value),
          leaseTerm: leaseTerm
        }));
        break;
      case 'leaseTerm':
        this.setState({
          downPaymentAmount: leaseDownPayment,
          leaseTerm: Number(inputData.value)
        });
        financeData.calculatorData.leaseTerm = Number(inputData.value);
        refetch(_objectSpread(_objectSpread({}, variables), {}, {
          downPaymentAmount: leaseDownPayment,
          leaseTerm: Number(inputData.value),
          financeTerm: financeTerm
        }));
        break;
      case 'buyInterestRate':
        {
          this.setState({
            rate: Number(inputData.value)
          });
          financeData.calculatorData.rate = Number(inputData.value);
          refetch(_objectSpread(_objectSpread({}, variables), {}, {
            downPaymentAmount: buyDownPayment,
            leaseTerm: leaseTerm,
            financeTerm: financeTerm,
            rate: Number(inputData.value),
            customerCash: !(!isDefaultRate && !inputData.isDefaultRate)
          }));
          break;
        }
      case 'buyTradeInValue':
      case 'leaseTradeInValue':
        this.setState({
          tradeInValue: Number(inputData.value)
        });
        financeData.calculatorData.tradeInValue = Number(inputData.value);
        refetch(_objectSpread(_objectSpread({}, variables), {}, {
          downPaymentAmount: buyDownPayment,
          leaseTerm: leaseTerm,
          financeTerm: financeTerm,
          tradeInValue: Number(inputData.value)
        }));
        break;
      case 'leaseAnnualMileage':
        this.setState({
          annualMileage: inputData.value
        });
        financeData.calculatorData.annualMileage = Number(inputData.value);
        refetch(_objectSpread(_objectSpread({}, variables), {}, {
          downPaymentAmount: leaseDownPayment,
          leaseTerm: leaseTerm,
          financeTerm: financeTerm,
          annualMileage: String(inputData.value)
        }));
        break;
      case 'zipCode':
        this.setState({
          zipCodeNumber: inputData.value
        });
        refetch(_objectSpread(_objectSpread({}, variables), {}, {
          leaseTerms: leaseTerms,
          zipCode: inputData.value
        }));
        break;
      default:
        break;
    }
    this.emitCalculationUpdate(data, financeData);
  };
  _proto.openShareDialog = function openShareDialog() {
    if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && window.navigator.share) {
      return window.navigator.share({
        title: this.shareTitle,
        url: this.shareURL
      });
    }
    this.setState({
      isShareDialogOpen: true
    });
    (0, _themeProvider.disableBodyScroll)();
  };
  _proto.layoutAdjuster = function layoutAdjuster() {
    this.setState({
      screenWidth: typeof window !== 'undefined' && window.innerWidth
    });
  };
  _proto.toggleCustomRate = function toggleCustomRate(e, data, refetch) {
    e.preventDefault();
    var prevDefaultRate = this.state.isDefaultRate;
    var isDefaultRate = !prevDefaultRate;
    this.setState(_objectSpread({
      isDefaultRate: isDefaultRate
    }, isDefaultRate && {
      rate: this._defaultRate
    }));

    // Refresh data with default rate
    if (isDefaultRate) {
      this.refreshData({
        name: 'buyInterestRate',
        value: '',
        isDefaultRate: isDefaultRate
      }, data, refetch);
    }
  };
  _proto.closeShareDialog = function closeShareDialog() {
    this.setState({
      isShareDialogOpen: false
    });
    (0, _themeProvider.enableBodyScroll)();
  };
  _proto.emitCalculationUpdate = function emitCalculationUpdate(data, financeData) {
    var updatePriceHoc = this.props.updatePriceHoc;
    if (typeof updatePriceHoc !== 'function') {
      return;
    }
    updatePriceHoc(_objectSpread(_objectSpread({}, financeData), {}, {
      msrp: (0, _get2["default"])(data, 'MSRP.value'),
      buyFor: (0, _get2["default"])(data, 'financeCalculation.monthlyAmount.value'),
      leaseFor: (0, _get2["default"])(data, 'leaseCalculation.monthlyAmount.value'),
      suffix: (0, _get2["default"])(data, 'monthSuffixLabel')
    }));
  };
  _proto.renderPaymentCalculator = function renderPaymentCalculator(data, refetch, loading, market) {
    var _this3 = this,
      _clsx2;
    var _this$props = this.props,
      _this$props$config = _this$props.config,
      currencyFormat = _this$props$config.currencyFormat,
      localeCode = _this$props$config.localeCode,
      isSmallForm = _this$props.isSmallForm,
      isNgc = _this$props.isNgc,
      hasLinks = _this$props.hasLinks,
      theme = _this$props.theme,
      combinedStepsLabels = _this$props.combinedStepsLabels,
      query = _this$props.router.location.query;
    var _this$state2 = this.state,
      isShareDialogOpen = _this$state2.isShareDialogOpen,
      isDefaultRate = _this$state2.isDefaultRate,
      selectedModelIndex = _this$state2.selectedModelIndex,
      selectedTab = _this$state2.selectedTab,
      financeTerm = _this$state2.financeTerm,
      leaseTerm = _this$state2.leaseTerm,
      financeTerms = _this$state2.financeTerms,
      leaseTerms = _this$state2.leaseTerms,
      annualMileage = _this$state2.annualMileage,
      paymentModel = _this$state2.paymentModel;
    var vehicles = data.vehicles,
      vehicleName = data.vehicleName,
      paymentCalculatorLabel = data.paymentCalculatorLabel,
      ctaText = data.ctaText,
      ctaUrl = data.ctaUrl,
      financeCalculation = data.financeCalculation,
      leaseCalculation = data.leaseCalculation,
      msrpDisclaimerNo = data.msrpDisclaimerNo,
      disclaimerLabel = data.disclaimerLabel,
      disclaimerList = data.disclaimerList,
      msrpDisclaimerId = data.msrpDisclaimerId,
      financeMonthlyPaymentDisclaimerId = data.financeMonthlyPaymentDisclaimerId,
      interestRateDisclaimerId = data.interestRateDisclaimerId,
      leaseMonthlyPaymentDisclaimerId = data.leaseMonthlyPaymentDisclaimerId,
      dueAtLeaseSigningDisclaimerId = data.dueAtLeaseSigningDisclaimerId,
      annualMileageDisclaimerId = data.annualMileageDisclaimerId,
      zipCodeTitle = data.zipCodeTitle,
      zipCodePlaceHolder = data.zipCodePlaceHolder,
      zipCodeForm = data.zipCodeForm;

    // If we query with one of financeTerm/leaseTerm we lose the labels coming
    // from the query(data), that's why we change labels
    var labels = (financeTerm || leaseTerm) && combinedStepsLabels.paymentCalculator ? combinedStepsLabels.paymentCalculator : data;
    var msrpLabel = labels.msrpLabel,
      monthSuffixLabel = labels.monthSuffixLabel;
    var modelSelectorData = {
      vehicles: vehicles,
      vehicleName: vehicleName,
      paymentCalculatorLabel: paymentCalculatorLabel,
      msrpLabel: msrpLabel,
      msrpDisclaimerNo: msrpDisclaimerNo,
      ctaText: ctaText,
      ctaUrl: ctaUrl,
      hideKeyFeatures: market === 'us'
    };
    this._defaultRate = this._defaultRate || (0, _get2["default"])(financeCalculation, 'rate');
    this.emitCalculationUpdate(data);
    var disclaimerData = {
      disclaimerLabel: disclaimerLabel,
      disclaimerList: disclaimerList
    };
    var containerClass = (0, _clsx3["default"])(theme['col-xs-12'], theme['col-sm-offset-1'], theme['col-sm-10']);
    var overMinimumLoan = (0, _get2["default"])(financeCalculation, 'amountFinanced.value', 0) > Number(labels.minimumLoanAllowance);
    var annualMileageIndexSelected = (0, _get2["default"])(leaseCalculation, 'annualMileage') ? leaseCalculation.annualMileage.indexOf(annualMileage) : 0;
    var annualMileageOptions = leaseCalculation.annualMileage && utils.annualMileageToOptions(leaseCalculation.annualMileage, annualMileageIndexSelected);
    var financeCalculationTerms = (0, _get2["default"])(financeCalculation, 'terms') || financeTerms ? utils.parseTerms(financeTerms || financeCalculation.terms) : false;
    var financeTermSelected = financeTerm || utils.getTermValue(financeCalculationTerms, _constants.DEFAULT_FINANCE_TERM);
    var leaseCalculationTerms = (0, _get2["default"])(leaseCalculation, 'terms') || leaseTerms ? utils.parseTerms(leaseTerms || leaseCalculation.terms) : false;
    var leaseTermSelected = leaseTerm || utils.getTermValue(leaseCalculationTerms, _constants.DEFAULT_LEASE_TERM);
    var leaseAnnualMileageSelected = annualMileage || utils.getDefaultValue(annualMileageOptions);
    this.shareURL = typeof window !== 'undefined' && window.location.origin + "/c/" + data.shareCode;
    this.shareTitle = selectedTab === 0 ? (0, _get2["default"])(financeCalculation, 'monthlyAmount.displayValue') + " " + data.perMonthLabel + " for " + utils.getTermValue(financeCalculation.terms) + " months" : (0, _get2["default"])(leaseCalculation, 'monthlyAmount.displayValue') + " " + data.perMonthLabel + " for " + utils.getTermValue(leaseCalculation.terms) + " months";
    this.shareText = selectedTab === 0 ? (0, _get2["default"])(financeCalculation, 'amountFinanced.displayValue') + " " + labels.amountFinancedLabel : (0, _get2["default"])(leaseCalculation, 'dueAtLeasing.displayValue') + ' ' + labels.dueLeasingLabel + "<sup className={styles.sup}>" + leaseCalculation.leaseSigningDisclaimerNo + "</sup>";
    var shareDialogInformation = {
      subtitle: this.shareTitle,
      description: this.shareText,
      headline: data.sharePaymentPlanHeadingText,
      imagePath: vehicles && vehicles[selectedModelIndex] && vehicles[selectedModelIndex].imagePath || '',
      imageAltText: vehicles && vehicles[selectedModelIndex] && vehicles[selectedModelIndex].imageAltText || '',
      url: this.shareURL,
      email: {
        subject: "Mitsubishi " + (selectedTab === 0 ? labels.buyTabLabel : labels.leaseTabLabel),
        text: this.shareTitle + " " + this.shareURL
      },
      twitter: {
        url: this.shareURL,
        text: this.shareTitle
      },
      facebook: {
        url: this.shareURL,
        text: this.shareTitle
      }
    };
    var carCalculationData = {
      query: query,
      type: selectedTab === 0 ? 'Finance' : 'Lease',
      calculation: selectedTab === 0 ? financeCalculation : leaseCalculation
    };
    var extraLinks = isNgc ? utils.deriveExtraLinks(carCalculationData, combinedStepsLabels) : {};
    var selectedCalculation = {
      0: financeCalculation,
      1: leaseCalculation
    }[selectedTab] || {};
    var _this$props$disclaime = this.props.disclaimerGroup,
      disclaimerGroup = _this$props$disclaime === void 0 ? {
        addPriceDisclaimer: null,
        priceDisclaimerId: '',
        disclaimerData: null,
        msrpDisclaimerId: '',
        monthlyMsrpDisclaimerId: '',
        buyMonthlyDisclaimerId: '',
        interestRateDisclaimerId: '',
        leaseMonthlyDisclaimerId: '',
        annualMileageDisclaimerId: '',
        dueAtLeaseSigningDisclaimerId: ''
      } : _this$props$disclaime;
    if (!paymentModel && vehicles && Number.isInteger(selectedModelIndex)) {
      var selectedModel = vehicles[selectedModelIndex];
      var initialPaymentModel = selectedModel && selectedModel.modelCode || '';
      this.setState({
        paymentModel: initialPaymentModel
      });
    }
    var isViableFinance = function isViableFinance() {
      if (financeCalculation && !financeCalculation.monthlyAmount) return false;
      if (financeCalculation && financeCalculation.monthlyAmount && !financeCalculation.monthlyAmount.value) return false;
      return true;
    };
    var isViableLease = function isViableLease() {
      if (leaseCalculation && !leaseCalculation.monthlyAmount) return false;
      if (leaseCalculation && leaseCalculation.monthlyAmount && !leaseCalculation.monthlyAmount.value) return false;
      return true;
    };
    var getDisabledTabs = function getDisabledTabs() {
      var tabs = [];
      if (!isViableFinance()) tabs.push(0);
      if (!isViableLease()) tabs.push(1);
      return tabs;
    };
    if (isSmallForm) {
      var _clsx;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.tabRef,
        className: (isNgc ? _calculationForm4["default"].smallCalcNgcWrapper : '') + " " + _calculationForm4["default"].smallCalcWrapper + "\n          " + (zipCodeForm === 'true' ? _calculationForm4["default"].smallCalcWrapperZipCode : '')
      }, /*#__PURE__*/_react["default"].createElement(_commonTabs.CommonTabs, {
        onTabChange: this.onTabClick,
        theme: theme,
        tabListClasses: _calculationForm4["default"].tabList,
        ctaWrapperClasses: _calculationForm4["default"].tabCta,
        variant: "dark",
        disclaimerData: disclaimerData,
        fullWidth: !isNgc,
        tabNames: [].concat(isViableFinance() ? [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
          className: (0, _clsx3["default"])(_calculationForm4["default"].tabTitle, _calculationForm4["default"].smallerTextStyle)
        }, labels.buyTabLabel), /*#__PURE__*/_react["default"].createElement("div", {
          className: "tabAmount"
        }, /*#__PURE__*/_react["default"].createElement(_useCountUp.CountUp, {
          isCounting: true,
          end: (0, _get2["default"])(financeCalculation, 'monthlyAmount.value', 0),
          duration: 1
        }, function (_ref4) {
          var value = _ref4.value;
          return /*#__PURE__*/_react["default"].createElement("span", null, overMinimumLoan ? /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
            format: "price",
            options: {
              displayValue: utils.formatPrice(value, currencyFormat, localeCode, 0)
            },
            addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
            priceDisclaimerId: disclaimerGroup.buyMonthlyDisclaimerId,
            disclaimerData: disclaimerGroup.disclaimerData
          }) : '-');
        })), overMinimumLoan && /*#__PURE__*/_react["default"].createElement("p", {
          className: (0, _clsx3["default"])(_calculationForm4["default"].tabDescription, _calculationForm4["default"].smallerTextStyle)
        }, monthSuffixLabel))] : [/*#__PURE__*/_react["default"].createElement("p", {
          className: (0, _clsx3["default"])(_calculationForm4["default"].tabTitle, _calculationForm4["default"].smallerTabUnavailable)
        }, labels.buyTabUnavailableLabel)], isViableLease() ? [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
          className: (0, _clsx3["default"])(_calculationForm4["default"].tabTitle, _calculationForm4["default"].smallerTextStyle)
        }, labels.leaseTabLabel), /*#__PURE__*/_react["default"].createElement("div", {
          className: "tabAmount"
        }, /*#__PURE__*/_react["default"].createElement(_useCountUp.CountUp, {
          isCounting: true,
          end: (0, _get2["default"])(leaseCalculation, 'monthlyAmount.value', 0),
          duration: 1
        }, function (_ref5) {
          var value = _ref5.value;
          return /*#__PURE__*/_react["default"].createElement("span", null, overMinimumLoan ? /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
            format: "price",
            options: {
              displayValue: utils.formatPrice(value, currencyFormat, localeCode, 0),
              currency: currencyFormat,
              locale: localeCode
            },
            addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
            priceDisclaimerId: disclaimerGroup.leaseMonthlyDisclaimerId,
            disclaimerData: disclaimerGroup.disclaimerData
          }) : '-');
        })), overMinimumLoan && /*#__PURE__*/_react["default"].createElement("p", {
          className: (0, _clsx3["default"])(_calculationForm4["default"].tabDescription, _calculationForm4["default"].smallerTextStyle)
        }, monthSuffixLabel))] : [labels.leaseTabUnavailableLabel ? /*#__PURE__*/_react["default"].createElement(_text.Text, {
          className: (0, _clsx3["default"])(_calculationForm4["default"].tabTitle, _calculationForm4["default"].smallerTabUnavailable, _calculationForm4["default"].disclaimerElement),
          text: labels.leaseTabUnavailableLabel,
          priceDisclaimerId: disclaimerGroup.leaseMonthlyDisclaimerId,
          disclaimerData: disclaimerGroup.disclaimerData
        }) : /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            display: 'none'
          }
        })]),
        selectedTab: selectedTab,
        disabledTabs: getDisabledTabs()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _calculationForm4["default"].form
      }, market === 'us' && zipCodeForm === 'true' ? /*#__PURE__*/_react["default"].createElement(_zipCodeForm.ZipCodeForm, {
        theme: theme,
        isSmallForm: isSmallForm,
        onChange: function onChange(dataInput) {
          return _this3.handleZipCodeChange(dataInput, data, refetch);
        },
        zipCodeTitle: zipCodeTitle,
        zipCodePlaceHolder: zipCodePlaceHolder
      }) : null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _calculationForm4["default"].formInner
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _calculationForm4["default"].totalDescription
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _calculationForm4["default"].totalDownPayment
      }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
        format: "price",
        options: {
          displayValue: (0, _get2["default"])(financeCalculation, 'downPayment.displayValue'),
          currency: currencyFormat,
          locale: localeCode
        },
        addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
        priceDisclaimerId: disclaimerGroup.msrpDisclaimerId,
        disclaimerData: disclaimerGroup.disclaimerData
      })), labels.downPaymentLabel, " ", _br || (_br = /*#__PURE__*/_react["default"].createElement("br", null)), overMinimumLoan ? /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
        format: "price",
        options: {
          displayValue: (0, _get2["default"])(financeCalculation, 'amountFinanced.displayValue'),
          currency: currencyFormat,
          locale: localeCode
        },
        addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
        priceDisclaimerId: disclaimerGroup.msrpDisclaimerId,
        disclaimerData: disclaimerGroup.disclaimerData
      }) : '-', ' ', labels.amountFinancedLabel, ".", ' ', labels.amountFinancedInclusionText, "."), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], _calculationForm4["default"].errorMessageContainer, (_clsx = {}, _clsx[_calculationForm4["default"].hidden] = overMinimumLoan, _clsx))
      }, !overMinimumLoan && /*#__PURE__*/_react["default"].createElement(_formElements.ErrorMessage, {
        theme: theme,
        message: labels.minimumLoanAllowanceError
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme.row, _calculationForm4["default"].formInner)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-md-5'])
      }, this.state.isDeafultUrlDataFetched && /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-6'])
      }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
        id: "buyDownPayment",
        label: labels.downPaymentLabel,
        theme: theme,
        name: "buyDownPayment",
        errorMessage: labels.errorMessageDownPaymentAndTradeIn,
        onChange: function onChange(dataInput) {
          return _this3.handleInputChange(dataInput, data, refetch);
        },
        pattern: labels.regexRestrictDecimalPricing,
        resetDefaultValue: loading,
        defaultValue: this.state.buyDownPayment || (0, _get2["default"])(financeCalculation, 'downPayment.displayValue') || '0.00'
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-6'])
      }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
        id: "buyTradeInValue",
        label: labels.tradeInValueLabel,
        theme: theme,
        name: "buyTradeInValue",
        errorMessage: labels.errorMessageDownPaymentAndTradeIn,
        onChange: function onChange(dataInput) {
          return _this3.handleInputChange(dataInput, data, refetch);
        },
        pattern: labels.regexRestrictDecimalPricing,
        resetDefaultValue: loading,
        defaultValue: this.state.buyTradeInValue || (0, _get2["default"])(financeCalculation, 'tradeInValue.displayValue') || '0.00'
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-12']
      }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.termsLabel), financeCalculationTerms && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
        name: "buyTerm",
        onChange: function onChange(inputData) {
          return _this3.handleButtonChange(inputData, data, refetch);
        },
        defaultValue: financeTermSelected,
        className: _calculationForm4["default"].inputMargin,
        theme: theme,
        tabs: financeCalculationTerms
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-md-7'], theme.row, _calculationForm4["default"].bottomContainer)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-sm-6'], theme['col-md-12'])
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _calculationForm4["default"].smallerTextStyle
      }, /*#__PURE__*/_react["default"].createElement("strong", {
        className: _calculationForm4["default"].amountOut
      }, overMinimumLoan ? /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
        format: "price",
        options: {
          displayValue: (0, _get2["default"])(financeCalculation, 'amountFinanced.displayValue'),
          currency: currencyFormat,
          locale: localeCode
        }
      }) : '-'), ' ', labels.amountFinancedLabel), /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _clsx3["default"])(_calculationForm4["default"].smallerTextStyle, _calculationForm4["default"].capitaliseFirstLetter, _calculationForm4["default"].amountFinancedInclusionText)
      }, labels.amountFinancedInclusionText)), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-sm-6'], theme['col-md-12'], _calculationForm4["default"].rateContainer)
      }, this.state.isDeafultUrlDataFetched && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(_calculationForm4["default"].rateInput)
      }, isDefaultRate ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.interestLabel, financeCalculation.interestRateDisclaimerNo && /*#__PURE__*/_react["default"].createElement(_text.Text, {
        text: " #" + financeCalculation.interestRateDisclaimerNo + "#",
        disclaimerData: data.disclaimerData,
        tag: "span"
      }), disclaimerGroup.interestRateDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
        text: "#" + disclaimerGroup.interestRateDisclaimerId + "#",
        disclaimerData: disclaimerGroup.disclaimerData,
        tag: "span",
        className: _calculationForm4["default"].disclaimer + " " + _calculationForm4["default"].smallDisclaimer + " " + _calculationForm4["default"].darkGreyDisclaimer
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: _calculationForm4["default"].defaultRateLabel
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _calculationForm4["default"].badge
      }, "Offer"), ' ', financeCalculation.rate, "% APR +", ' ', (0, _get2["default"])(financeCalculation, 'customerCashback.displayValue'))) : /*#__PURE__*/_react["default"].createElement(_input["default"], {
        id: "buyInterestRate",
        label: labels.interestLabel,
        disclaimerNo: financeCalculation.interestRateDisclaimerNo,
        interestRateDisclaimerId: disclaimerGroup.interestRateDisclaimerId,
        disclaimerData: disclaimerGroup.disclaimerData,
        theme: theme,
        name: "buyInterestRate",
        errorMessage: financeCalculation.validationRateErrorMsg,
        onChange: function onChange(dataInput) {
          return _this3.handleInputChange(dataInput, data, refetch);
        },
        pattern: labels.regexRestrictDecimalRating,
        resetDefaultValue: loading,
        defaultValue: (this.state.buyInterestRate || financeCalculation.rate) + "%"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(_calculationForm4["default"].defaultRateBtn)
      }, isDefaultRate ? /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        classes: [_calculationForm4["default"].ctaBtn],
        clickEvent: function clickEvent(e) {
          return _this3.toggleCustomRate(e, data, refetch);
        },
        data: {
          priority: 'trivial',
          label: labels.customRateLabel
        }
      }) : /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        classes: [_calculationForm4["default"].ctaBtn, _calculationForm4["default"].ctaBtnToggled],
        clickEvent: function clickEvent(e) {
          return _this3.toggleCustomRate(e, data, refetch);
        },
        data: {
          priority: 'trivial',
          label: labels.defaultRateLabel
        }
      })))))), hasLinks && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], {
        theme: theme,
        data: _objectSpread(_objectSpread({}, data), extraLinks),
        onShareDialogClick: this.openShareDialog,
        calculation: selectedCalculation
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _calculationForm4["default"].form
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _calculationForm4["default"].formInner
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _calculationForm4["default"].totalDescription
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _calculationForm4["default"].totalDownPayment
      }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
        format: "price",
        options: {
          displayValue: (0, _get2["default"])(leaseCalculation, 'dueAtLeasing.displayValue'),
          currency: currencyFormat,
          locale: localeCode
        },
        addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
        priceDisclaimerId: disclaimerGroup.msrpDisclaimerId,
        disclaimerData: disclaimerGroup.disclaimerData
      })), /*#__PURE__*/_react["default"].createElement("span", null, labels.dueLeasingLabel, ' ', /*#__PURE__*/_react["default"].createElement("sup", {
        className: _calculationForm4["default"].sup
      }, leaseCalculation.leaseSigningDisclaimerNo)), /*#__PURE__*/_react["default"].createElement("span", {
        className: _calculationForm4["default"].spanBlock
      }, labels.dueLeasingInclusionText)), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-md-8'])
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-6']
      }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
        id: "leaseDownPayment",
        label: labels.downPaymentLabel,
        theme: theme,
        name: "leaseDownPayment",
        errorMessage: labels.errorMessageDownPaymentAndTradeIn,
        onChange: function onChange(dataInput) {
          return _this3.handleInputChange(dataInput, data, refetch);
        },
        pattern: labels.regexRestrictDecimalPricing,
        resetDefaultValue: loading,
        defaultValue: (0, _get2["default"])(leaseCalculation, 'downPayment.displayValue') || '0.00'
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-6']
      }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
        id: "leaseTradeInValue",
        label: labels.tradeInValueLabel,
        theme: theme,
        name: "leaseTradeInValue",
        errorMessage: labels.errorMessageDownPaymentAndTradeIn,
        onChange: function onChange(dataInput) {
          return _this3.handleInputChange(dataInput, data, refetch);
        },
        pattern: labels.regexRestrictDecimalPricing,
        resetDefaultValue: loading,
        defaultValue: (0, _get2["default"])(leaseCalculation, 'tradeInValue.displayValue') || '0.00'
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-sm-6'])
      }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.annualMileageLabel, disclaimerGroup.annualMileageDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
        text: "#" + disclaimerGroup.annualMileageDisclaimerId + "#",
        disclaimerData: disclaimerGroup.disclaimerData,
        tag: "span",
        className: _calculationForm4["default"].disclaimer + " " + _calculationForm4["default"].smallDisclaimer + " " + _calculationForm4["default"].darkGreyDisclaimer
      })), annualMileageOptions && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
        name: "leaseAnnualMileage",
        onChange: function onChange(inputData) {
          return _this3.handleButtonChange(inputData, data, refetch);
        },
        defaultValue: leaseAnnualMileageSelected,
        className: _calculationForm4["default"].inputMargin,
        theme: theme,
        tabs: annualMileageOptions
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-sm-6'])
      }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.termsLabel), leaseCalculationTerms && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
        name: "leaseTerm",
        onChange: function onChange(inputData) {
          return _this3.handleButtonChange(inputData, data, refetch);
        },
        defaultValue: leaseTermSelected,
        className: _calculationForm4["default"].inputMargin,
        theme: theme,
        tabs: leaseCalculationTerms
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-md-4'])
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _calculationForm4["default"].smallerTextStyle
      }, /*#__PURE__*/_react["default"].createElement("strong", {
        className: _calculationForm4["default"].amountOut
      }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
        format: "price",
        options: {
          displayValue: (0, _get2["default"])(leaseCalculation, 'dueAtLeasing.displayValue'),
          currency: currencyFormat,
          locale: localeCode
        },
        addPriceDisclaimer: disclaimerGroup.addPriceDisclaimer,
        priceDisclaimerId: disclaimerGroup.dueAtLeaseSigningDisclaimerId,
        disclaimerData: disclaimerGroup.disclaimerData
      })), ' ', labels.dueLeasingLabel), /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _clsx3["default"])(_calculationForm4["default"].smallerTextStyle, _calculationForm4["default"].capitaliseFirstLetter)
      }, labels.dueLeasingInclusionText)))), hasLinks && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], {
        theme: theme,
        data: _objectSpread(_objectSpread({}, data), extraLinks),
        onShareDialogClick: this.openShareDialog,
        calculation: selectedCalculation
      }))))));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculationForm4["default"].calculationForm
    }, isShareDialogOpen && /*#__PURE__*/_react["default"].createElement(_commonShareDialog.CommonShareDialog, (0, _extends2["default"])({
      onClose: this.closeShareDialog
    }, shareDialogInformation, {
      theme: theme
    })), loading && (_CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null))), /*#__PURE__*/_react["default"].createElement(_modelSelector.ModelSelector, {
      key: selectedModelIndex,
      onChange: function onChange(modelIndex, selectedModel) {
        return _this3.handleModelChange(modelIndex, selectedModel, refetch);
      },
      className: (0, _clsx3["default"])(containerClass, _calculationForm4["default"].modelSelector),
      theme: theme,
      data: modelSelectorData,
      defaultModelIndex: selectedModelIndex,
      addPriceDisclaimer: msrpDisclaimerId,
      priceDisclaimerId: msrpDisclaimerId,
      disclaimerData: data.disclaimerData
    }), market === 'us' && zipCodeForm === 'true' ? /*#__PURE__*/_react["default"].createElement(_zipCodeForm.ZipCodeForm, {
      theme: theme,
      onChange: function onChange(dataInput) {
        return _this3.handleZipCodeChange(dataInput, data, refetch);
      },
      zipCodeTitle: zipCodeTitle,
      zipCodePlaceHolder: zipCodePlaceHolder
    }) : null, /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.tabRef
    }, /*#__PURE__*/_react["default"].createElement(_commonTabs.CommonTabs, {
      onTabChange: this.onTabClick,
      theme: theme,
      tabListClasses: _calculationForm4["default"].tabList,
      ctaWrapperClasses: _calculationForm4["default"].tabCta,
      variant: "dark",
      disclaimerData: disclaimerData,
      fullWidth: true,
      tabNames: [].concat(isViableFinance() ? [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: "tabTitle"
      }, labels.buyTabLabel), /*#__PURE__*/_react["default"].createElement("div", {
        className: "tabAmount"
      }, /*#__PURE__*/_react["default"].createElement(_useCountUp.CountUp, {
        isCounting: true,
        end: (0, _get2["default"])(financeCalculation, 'monthlyAmount.value', 0),
        duration: 1
      }, function (_ref6) {
        var value = _ref6.value;
        return /*#__PURE__*/_react["default"].createElement("span", null, overMinimumLoan ? utils.formatPrice(value, currencyFormat, localeCode) : '-');
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "tabDescription"
      }, data.perMonthLabel, (0, _get2["default"])(financeCalculation, 'monthlyDisclaimerNo') && /*#__PURE__*/_react["default"].createElement("sup", null, financeCalculation.monthlyDisclaimerNo), financeMonthlyPaymentDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
        text: "#" + financeMonthlyPaymentDisclaimerId + "#",
        disclaimerData: data.disclaimerData,
        tag: "span",
        className: _calculationForm4["default"].disclaimer + " " + _calculationForm4["default"].darkGreyDisclaimer
      }))))] : [/*#__PURE__*/_react["default"].createElement("div", {
        className: "tabUnavailable"
      }, labels.buyTabUnavailableLabel)], isViableLease() ? [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: "tabTitle"
      }, labels.leaseTabLabel), /*#__PURE__*/_react["default"].createElement("div", {
        className: "tabAmount"
      }, /*#__PURE__*/_react["default"].createElement(_useCountUp.CountUp, {
        isCounting: true,
        end: (0, _get2["default"])(leaseCalculation, 'monthlyAmount.value', 0),
        duration: 1
      }, function (_ref7) {
        var value = _ref7.value;
        return /*#__PURE__*/_react["default"].createElement("span", null, overMinimumLoan ? utils.formatPrice(value, currencyFormat, localeCode) : '-');
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "tabDescription"
      }, data.perMonthLabel, (0, _get2["default"])(financeCalculation, 'monthlyDisclaimerNo') && /*#__PURE__*/_react["default"].createElement("sup", null, leaseCalculation.monthlyDisclaimerNo), leaseMonthlyPaymentDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
        text: "#" + leaseMonthlyPaymentDisclaimerId + "#",
        disclaimerData: data.disclaimerData,
        tag: "span",
        className: _calculationForm4["default"].disclaimer + " " + _calculationForm4["default"].darkGreyDisclaimer
      }))))] : labels.leaseTabUnavailableLabel ? [/*#__PURE__*/_react["default"].createElement(_text.Text, {
        text: labels.leaseTabUnavailableLabel,
        className: _calculationForm4["default"].leaseTabUnavailableLabel,
        disclaimerData: data.disclaimerData
      })] : []),
      selectedTab: selectedTab,
      disabledTabs: getDisabledTabs()
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculationForm4["default"].form
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculationForm4["default"].formInner
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _calculationForm4["default"].totalDescription
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _calculationForm4["default"].totalDownPayment
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        displayValue: (0, _get2["default"])(financeCalculation, 'downPayment.displayValue'),
        currency: currencyFormat,
        locale: localeCode
      },
      addPriceDisclaimer: data.addPriceDisclaimer,
      priceDisclaimerId: data.priceDisclaimerId,
      disclaimerData: data.disclaimerData
    })), labels.downPaymentLabel, " ", _br2 || (_br2 = /*#__PURE__*/_react["default"].createElement("br", null)), overMinimumLoan ? /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        displayValue: (0, _get2["default"])(financeCalculation, 'amountFinanced.displayValue'),
        currency: currencyFormat,
        locale: localeCode
      },
      addPriceDisclaimer: data.addPriceDisclaimer,
      priceDisclaimerId: data.priceDisclaimerId,
      disclaimerData: data.disclaimerData
    }) : '-', ' ', labels.amountFinancedLabel, ".", ' ', labels.amountFinancedInclusionText, "."), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(theme['col-xs-12'], _calculationForm4["default"].errorMessageContainer, (_clsx2 = {}, _clsx2[_calculationForm4["default"].hidden] = overMinimumLoan, _clsx2))
    }, !overMinimumLoan && /*#__PURE__*/_react["default"].createElement(_formElements.ErrorMessage, {
      theme: theme,
      message: labels.minimumLoanAllowanceError
    }))), this.state.isDeafultUrlDataFetched && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-6']
    }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
      id: "buyDownPayment",
      label: labels.downPaymentLabel,
      theme: theme,
      name: "buyDownPayment",
      errorMessage: labels.errorMessageDownPaymentAndTradeIn,
      onChange: function onChange(dataInput) {
        return _this3.handleInputChange(dataInput, data, refetch);
      },
      pattern: labels.regexRestrictDecimalPricing,
      resetDefaultValue: loading,
      defaultValue: this.state.buyDownPayment || (0, _get2["default"])(financeCalculation, 'downPayment.displayValue') || '0.00'
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-6']
    }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
      id: "buyTradeInValue",
      label: labels.tradeInValueLabel,
      theme: theme,
      name: "buyTradeInValue",
      errorMessage: labels.errorMessageDownPaymentAndTradeIn,
      onChange: function onChange(dataInput) {
        return _this3.handleInputChange(dataInput, data, refetch);
      },
      pattern: labels.regexRestrictDecimalPricing,
      resetDefaultValue: loading,
      defaultValue: this.state.buyTradeInValue || (0, _get2["default"])(financeCalculation, 'tradeInValue.displayValue') || '0.00'
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.termsLabel), financeCalculationTerms && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
      name: "buyTerm",
      onChange: function onChange(inputData) {
        return _this3.handleButtonChange(inputData, data, refetch);
      },
      defaultValue: financeTermSelected,
      className: _calculationForm4["default"].inputMargin,
      theme: theme,
      tabs: financeCalculationTerms
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, this.state.isDeafultUrlDataFetched && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-md-6'])
    }, isDefaultRate ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.interestLabel, financeCalculation.interestRateDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, financeCalculation.interestRateDisclaimerNo), interestRateDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: "#" + interestRateDisclaimerId + "#",
      disclaimerData: data.disclaimerData,
      tag: "span",
      className: _calculationForm4["default"].disclaimer + " " + _calculationForm4["default"].smallDisclaimer + " " + _calculationForm4["default"].darkGreyDisclaimer
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: _calculationForm4["default"].defaultRateLabel
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _calculationForm4["default"].badge
    }, "Offer"), ' ', (0, _get2["default"])(financeCalculation, 'rate'), "% APR +", ' ', (0, _get2["default"])(financeCalculation, 'customerCashback.displayValue'))) : /*#__PURE__*/_react["default"].createElement(_input["default"], {
      id: "buyInterestRate",
      label: labels.interestLabel,
      disclaimerNo: financeCalculation.interestRateDisclaimerNo,
      interestRateDisclaimerId: interestRateDisclaimerId,
      disclaimerData: data.disclaimerData,
      theme: theme,
      name: "buyInterestRate",
      errorMessage: (0, _get2["default"])(financeCalculation, 'validationRateErrorMsg'),
      onChange: function onChange(dataInput) {
        return _this3.handleInputChange(dataInput, data, refetch);
      },
      pattern: labels.regexRestrictDecimalRating,
      minVal: "0",
      maxVal: "100",
      resetDefaultValue: loading,
      defaultValue: (this.state.buyInterestRate || financeCalculation.rate) + "%"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(theme['col-xs-12'], theme['col-md-6'], _calculationForm4["default"].defaultRateBtn)
    }, isDefaultRate ? /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      classes: [_calculationForm4["default"].ctaBtn],
      clickEvent: function clickEvent(e) {
        return _this3.toggleCustomRate(e, data, refetch);
      },
      data: {
        priority: 'trivial',
        label: labels.customRateLabel
      }
    }) : /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      classes: [_calculationForm4["default"].ctaBtn],
      clickEvent: function clickEvent(e) {
        return _this3.toggleCustomRate(e, data, refetch);
      },
      data: {
        priority: 'trivial',
        label: labels.defaultRateLabel
      }
    })))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], {
      theme: theme,
      data: data,
      onShareDialogClick: this.openShareDialog,
      calculation: selectedCalculation
    }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paymentGraph["default"], {
      className: _calculationForm4["default"].paymentGraph,
      imagePath: vehicles && vehicles[selectedModelIndex] && vehicles[selectedModelIndex].imagePath,
      imageAltText: vehicles && vehicles[selectedModelIndex] && vehicles[selectedModelIndex].imageAltText,
      percentage: (0, _get2["default"])(financeCalculation, 'monthlyAmount.value') / (0, _get2["default"])(financeCalculation, 'downPayment.value') * 100,
      totalLeft: (0, _get2["default"])(financeCalculation, 'downPayment.displayValue'),
      totalLeftLabel: labels.downPaymentLabel,
      totalRight: (0, _get2["default"])(financeCalculation, 'monthlyAmount.displayValue'),
      totalRightLabel: data.monthlyLabel,
      summary: (0, _get2["default"])(financeCalculation, 'amountFinanced.displayValue') + " " + labels.amountFinancedInclusionText
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculationForm4["default"].form
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paymentGraph["default"], {
      className: _calculationForm4["default"].paymentGraph,
      imagePath: vehicles && vehicles[selectedModelIndex] && vehicles[selectedModelIndex].imagePath,
      imageAltText: vehicles && vehicles[selectedModelIndex] && vehicles[selectedModelIndex].imageAltText,
      percentage: (0, _get2["default"])(leaseCalculation, 'dueAtLeasing.value') / (0, _get2["default"])(leaseCalculation, 'downPayment.value') * 100,
      totalLeft: (0, _get2["default"])(leaseCalculation, 'dueAtLeasing.displayValue'),
      totalLeftLabel: labels.dueLeasingLabel,
      totalRight: (0, _get2["default"])(leaseCalculation, 'monthlyAmount.displayValue'),
      leaseSigningDisclaimerNo: leaseCalculation.leaseSigningDisclaimerNo,
      totalRightLabel: data.monthlyLabel,
      summary: labels.dueLeasingInclusionText,
      dueAtLeaseSigningDisclaimerId: dueAtLeaseSigningDisclaimerId,
      disclaimerData: data.disclaimerData
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculationForm4["default"].formInner
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _calculationForm4["default"].totalDescription
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _calculationForm4["default"].totalDownPayment
    }, (0, _get2["default"])(leaseCalculation, 'dueAtLeasing.displayValue')), /*#__PURE__*/_react["default"].createElement("span", null, labels.dueLeasingLabel, ' ', /*#__PURE__*/_react["default"].createElement("sup", {
      className: _calculationForm4["default"].sup
    }, (0, _get2["default"])(leaseCalculation, 'leaseSigningDisclaimerNo'))), /*#__PURE__*/_react["default"].createElement("span", {
      className: _calculationForm4["default"].spanBlock
    }, labels.dueLeasingInclusionText)), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-6']
    }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
      id: "leaseDownPayment",
      label: labels.downPaymentLabel,
      theme: theme,
      name: "leaseDownPayment",
      errorMessage: labels.errorMessageDownPaymentAndTradeIn,
      onChange: function onChange(dataInput) {
        return _this3.handleInputChange(dataInput, data, refetch);
      },
      pattern: labels.regexRestrictDecimalPricing,
      resetDefaultValue: loading,
      defaultValue: (0, _get2["default"])(leaseCalculation, 'downPayment.displayValue') || '0.00'
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-6']
    }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
      id: "leaseTradeInValue",
      label: labels.tradeInValueLabel,
      theme: theme,
      name: "leaseTradeInValue",
      errorMessage: labels.errorMessageDownPaymentAndTradeIn,
      onChange: function onChange(dataInput) {
        return _this3.handleInputChange(dataInput, data, refetch);
      },
      pattern: labels.regexRestrictDecimalPricing,
      resetDefaultValue: loading,
      defaultValue: (0, _get2["default"])(leaseCalculation, 'tradeInValue.displayValue') || '0.00'
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.annualMileageLabel, annualMileageDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: "#" + annualMileageDisclaimerId + "#",
      disclaimerData: data.disclaimerData,
      tag: "span",
      className: _calculationForm4["default"].mileageDisclaimer
    })), annualMileageOptions && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
      name: "leaseAnnualMileage",
      onChange: function onChange(inputData) {
        return _this3.handleButtonChange(inputData, data, refetch);
      },
      defaultValue: leaseAnnualMileageSelected,
      className: _calculationForm4["default"].inputMargin,
      theme: theme,
      tabs: annualMileageOptions,
      buttonLabelFormatter: function buttonLabelFormatter(value) {
        return value.toLocaleString();
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.termsLabel), leaseCalculationTerms && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
      name: "leaseTerm",
      onChange: function onChange(inputData) {
        return _this3.handleButtonChange(inputData, data, refetch);
      },
      defaultValue: leaseTermSelected,
      className: _calculationForm4["default"].inputMargin,
      theme: theme,
      tabs: leaseCalculationTerms
    })))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], {
      theme: theme,
      data: data,
      onShareDialogClick: this.openShareDialog,
      calculation: selectedCalculation
    })))))));
  };
  _proto.render = function render() {
    var _this4 = this;
    var _this$props2 = this.props,
      market = _this$props2.market,
      language = _this$props2.language,
      path = _this$props2.path,
      location = _this$props2.router.location,
      skipServerRendering = _this$props2.skipServerRendering,
      isSmallForm = _this$props2.isSmallForm,
      theme = _this$props2.theme,
      additionalPriceGroup = _this$props2.additionalPriceGroup;
    var paymentVehicle = (0, _get2["default"])(location, 'query.paymentVehicle');
    var zipCode = (0, _get2["default"])(location, 'query.zipCode');
    var url = (0, _get2["default"])(location, 'query.url');
    var _this$state3 = this.state,
      isDefaultRate = _this$state3.isDefaultRate,
      paymentModel = _this$state3.paymentModel,
      financeTerm = _this$state3.financeTerm,
      leaseTerm = _this$state3.leaseTerm,
      downPaymentAmount = _this$state3.downPaymentAmount,
      rate = _this$state3.rate,
      tradeInValue = _this$state3.tradeInValue,
      annualMileage = _this$state3.annualMileage;
    if (!isSmallForm && !paymentVehicle) {
      return null;
    }
    var query = isSmallForm ? _query.CALCULATION_FORM_QUERY_INLINE : _query.CALCULATION_FORM_QUERY;
    var exteriorColorPrice = additionalPriceGroup ? additionalPriceGroup.color : 0;
    var interiorColorPrice = additionalPriceGroup ? additionalPriceGroup.fabric : 0;
    var packagePrices = additionalPriceGroup ? additionalPriceGroup["package"] : 0;
    var accessoriesPrices = additionalPriceGroup ? additionalPriceGroup.accessory : 0;
    var exteriorColorCode = additionalPriceGroup ? additionalPriceGroup.colorCode : '';
    var interiorColorCode = additionalPriceGroup ? additionalPriceGroup.fabricCode : '';
    var packageCodes = additionalPriceGroup ? additionalPriceGroup.packageCodes : [];
    var accessoryCodes = additionalPriceGroup ? additionalPriceGroup.accessoryCodes : [];
    var variables = utils.getQueryVariables(_objectSpread({
      location: location,
      variables: {
        path: path,
        market: market,
        language: language,
        paymentVehicle: paymentVehicle,
        zipCode: zipCode,
        paymentModel: paymentModel,
        url: url,
        exteriorColorPrice: exteriorColorPrice,
        interiorColorPrice: interiorColorPrice,
        packagePrices: packagePrices,
        accessoriesPrices: accessoriesPrices
      }
    }, isSmallForm && {
      inlineVariables: {
        isDefaultRate: isDefaultRate,
        paymentModel: paymentModel,
        downPaymentAmount: downPaymentAmount,
        financeTerm: financeTerm,
        leaseTerm: leaseTerm,
        rate: rate,
        tradeInValue: tradeInValue,
        annualMileage: annualMileage,
        exteriorColorCode: exteriorColorCode,
        interiorColorCode: interiorColorCode,
        packageCodes: packageCodes,
        accessoryCodes: accessoryCodes
      }
    }));
    return /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, {
      skip: skipServerRendering
    }, /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: query,
      variables: variables,
      onCompleted: this.onQueryData
    }, function (_ref8) {
      var loading = _ref8.loading,
        rawData = _ref8.data,
        error = _ref8.error,
        refetch = _ref8.refetch;
      var data = _this4.getGQLData(rawData);
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_commonErrorMessage.CommonErrorMessage, {
          theme: theme,
          errorTitle: data.calculationErrorTitle,
          errorContent: data.calculationErrorText,
          viewHomePage: data.viewHomePageLabel,
          viewHomePagePath: data.viewHomePagePath
        });
      }
      if (data) {
        return _this4.renderPaymentCalculator(data, refetch, loading, market);
      }
      return _CommonLoader2 || (_CommonLoader2 = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null));
    }));
  };
  return CalculationForm;
}(_react["default"].PureComponent);
CalculationForm.displayName = 'CalculationForm';
CalculationForm.defaultProps = {
  skipServerRendering: true,
  inlineData: {},
  combinedStepsLabels: {}
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language,
    path: props.path || state.Config.path,
    config: props.config || state.Config
  };
};
var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(CalculationForm));
exports["default"] = _default;